export default "__VITE_ASSET__UxAn3xF4__"